


























import { Component, Prop, Vue } from 'vue-property-decorator'
import { findDarkValue, findLightValue } from '@/utils'
import bus, { SYNC } from '@/utils/bus-event'
import accountService from '@/services/AccountService'
import IAccount from '@/models/IAccount'
import IColor from '@/models/IColor'
import FabButton from '@/components/FabButton.vue'
import ITransaction from '../models/ITransaction'
import transactionService from '../services/TransactionService'
import TransactionType from '../enums/TransactionType'
import colors from '../data/colors'

const GRADIENT = false

@Component
export default class AccountCard extends Vue {
  @Prop({ type: Object, required: true })
  public account!: IAccount
  public transactions: ITransaction[] = []

  public async mounted() {
    this.transactions = await transactionService.getAllByAccountId(
      this.account._id
    )
  }

  public findDarkValue(color: string): string | null {
    return findDarkValue(color)
  }

  public goToAccount(id: string): void {
    this.$router.push({ name: 'account', params: { id } })
  }

  public getColor(color: string | null): any | null {
    if (!color) {
      return null
    }

    return {
      background: GRADIENT
        ? `linear-gradient(135deg, ${color}, ${findLightValue(color)})`
        : color,
      color: findDarkValue(color)
    }
  }

  private get totalCost(): number {
    return transactionService.getTotalCost(
      this.transactions,
      this.account.mainCurrency.code
    )
  }
}
